import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import Hero from "src/components/Hero/Hero";
import { Col, Row } from "react-bootstrap";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";

const WelcomeBackBonus = () => {
  const { t, i18n } = useTranslation();
  const responsiveBgImage = useResponsiveImageUrl(
    "promotions/gaming-machines/welcome-back-bonus/content-bg.jpg"
  );
  return (
    <WelcomeBackBonusDiv>
      <Hero
        bgImage="promotions/gaming-machines/welcome-back-bonus/Welcome-back-bonus-hero-image-2400x800px.jpg"
        buttonSettings={null}
        image={`promotions/gaming-machines/welcome-back-bonus/Welcome-back-bonus-logo-2400x2400px-${i18n.language}.png`}
        darkenBg={0.5}
        title={t("egd.welcomeBonus.hero.title")}
        descriptionBgColor="#01e1c9"
      />
      <MainContentDiv bgImage={responsiveBgImage}>
        <container-div>
          <Row className="g-4 m-2" id="">
            <Col className="mt-4 mb-4 m-0" xs={12} md={4}>
              <ResponsiveImage
                src={"promotions/gaming-machines/welcome-back-bonus/PG.png"}
                alt="STEP 1 - VISIT PLAYGROUND"
              />
            </Col>
            <Col className="mt-0" xs={12} md={7}>
              <ReactMarkdown>
                {t("egd.welcomeBonus.content.step1.title")}
              </ReactMarkdown>
              <ReactMarkdown>
                {t("egd.welcomeBonus.content.step1.text")}
              </ReactMarkdown>
            </Col>
          </Row>
          <Row className="g-4 m-4" id="">
            <Col className="mt-0 mb-4 m-0" xs={12} md={4}>
              <ResponsiveImage
                src={`promotions/gaming-machines/welcome-back-bonus/25-${i18n.language}.png`}
                alt="STEP 2 - ENJOY $25 IN FREE PLAY"
              />
            </Col>
            <Col className="mt-0" xs={12} md={7}>
              <ReactMarkdown>
                {t("egd.welcomeBonus.content.step2.title")}
              </ReactMarkdown>
              <ReactMarkdown>
                {t("egd.welcomeBonus.content.step2.text")}
              </ReactMarkdown>
            </Col>
          </Row>
          <Row className="g-4 m-4" id="">
            <Col className="mt-0 mb-4 m-0" xs={12} md={4}>
              <ResponsiveImage
                src={`promotions/gaming-machines/welcome-back-bonus/50-${i18n.language}.png`}
                alt="STEP 2 - ENJOY $25 IN FREE PLAY"
              />
            </Col>
            <Col className="mt-0" xs={12} md={7}>
              <ReactMarkdown>
                {t("egd.welcomeBonus.content.step3.title")}
              </ReactMarkdown>
              <ReactMarkdown>
                {t("egd.welcomeBonus.content.step3.text")}
              </ReactMarkdown>
            </Col>
          </Row>
          <Row className="g-4 mb-0 mt-0 align-items-center center-text" id="">
            <Col className="mt-0" xs={12} md={12}>
              <ReactMarkdown>
                {t("egd.welcomeBonus.content.text")}
              </ReactMarkdown>
              <ReactMarkdown>
                {t("egd.welcomeBonus.content.smallText")}
              </ReactMarkdown>
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
    </WelcomeBackBonusDiv>
  );
};
const WelcomeBackBonusDiv = styled.div`
  width: 100%;
  height: auto;
  background: var(--lightblack);
  color: var(--white);
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
  .small {
    text-align: center;
  }
  .hero_text_container {
    h1 {
      color: var(--black);
      text-shadow: none;
    }
  }
  h4 {
    strong {
      color: #01e1c9;
    }
  }
`;

const MainContentDiv = styled.div`
  background: url(${(props) => props.bgImage});
  background-size: cover;
  background-position: center;
  container-div {
    background-color: rgba(0, 0, 0, 0.4);
    max-width: 900px;
    @media (min-width: 992px) {
      padding: 3rem 1rem;
    }
  }
  height: auto;
  width: 100%;
  text-align: left;
  ul {
    list-style: disc;
    p {
      margin: 10px 0;
    }
    li {
      white-space: unset;
    }
  }
  .row {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    /* gap: 1rem; */
    margin: 0 auto;
    position: relative;
    img {
      max-width: 200px;
      object-fit: cover;
      margin: 0 auto;
    }
    .col {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    @media (max-width: 991px) {
      margin: 0 !important;
    }
  }
  .center-text {
    text-align: center;
    strong {
      color: #01e1c9;
    }
  }
  @media (max-width: 991px) {
    .subtitle-section {
      h2 {
        font-size: 1.5rem;
      }
    }
  }
`;
export default WelcomeBackBonus;
